import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Route, Switch } from 'react-router-dom';
import ErrorDialog from '../../components/dialogs/ErrorDialog';
import SavingDialog from '../../components/dialogs/SavingDailog';
import { post } from '../../modules/utility';

import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';

import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';

//- container
import LayoutContainer from '../../containers/Layout';

//- Pages / Route
import Dashboard from './Dashboard/Dashboard';
import PleaseClockIn from './Dashboard/PleaseClockIn';
import DebugCommodities from './DebugCommodities';
import { CircularProgress, IconButton, Slide, Snackbar, SnackbarContent } from '@material-ui/core';
import Refresh from '@material-ui/icons/Refresh';

const SlideUpTransition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const stlOrange = '#E9791E';

const styles = () => {
	return {
		root: {
			width: '100%',
			fontSize: '2.5vw',
			zIndex: 1,
			backgroundColor: '#fff',
		},

		bottomIcon: {
			//height: 38,
			//width: 44,
			height: '7vw',
			width: '7vw',
		},
		bottomIconDisabled: {
			height: '7vw',
			width: '7vw',
			color: '#bbb',
		},
		bottomLabel: {
			fontSize: '110% !important',
		},
		bottomLabelDisabled: {
			color: '#aaa',
			fontSize: '110%',
		},
		pushContainer: {
			width: '100%',
			fontSize: '3.5vw',
			border: '2px solid',
			borderColor: stlOrange,
			background: 'white',
			color: 'black',
			display: 'block',
			//		marginRight: '2vw',
			//marginLeft: '2vw',
			padding: '2vw',
		},
		pushRoot: {
			//width: '100%',
			left: '8px',
			right: '8px',
			transform: 'none',
		},
		pushInner: {
			display: 'flex',
			alignItems: 'center',
			boxSizing: 'border-box',
			width: '100%',
		},
		pushActions: {
			width: '100%',
			fontSize: '70%',
			display: 'flex',
			justifyContent: 'space-around',
		},
		icon: {
			fontSize: '4vw',
		},
		pushButton: {
			//fontSize: '80%',
			fontSize: '4vw',
		},
		pushMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		pushIcon: {
			marginRight: '1vw',
			color: stlOrange,
		},
	};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL or contact support</h2>
	</div>
);

const TAB_VALUES = {
	HOME: 0,
	LOGOUT: 1,
};

if (!window.sphere) {
	window.sphere = {};
	window.sphere.openPusNotification = _.noop;
}

/*
setTimeout(() => {
	window.sphere.openPusNotification('Load 123345 has a change' });
}, 2000);
*/

class MobileLayout extends Component {
	constructor(props) {
		super(props);

		const navTab = 0;

		this.state = {
			drawerOpen: false,
			isAuthErrorClosed: false,
			timeClockAnalysisResult: undefined,
			isTimeClockFetching: true,
			navTab,
			pushNotificationIsOpen: false,
		};

		window.sphere.openPusNotification = ({ message }) => {
			console.log('THE MESSAGE', message);
			this.setState({
				pushNotificationIsOpen: true,
				pushNotificationMessage: message,
			});
		};
		window.sphere.openPusNotification.bind(this);
	}

	// On first mount we check if they are clocked in
	componentDidMount() {
		document.documentElement.style.backgroundColor = 'white';
		document.body.style.marginBottom = '100px';
		this.getShiftAnalysis({ callback: _.noop });
	}

	getShiftAnalysis = ({ callback }) => {
		const { showErrors } = this.props;

		post({
			method: 'timeClockShift.user.getShiftAnalysis',
			params: {},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return callback(err);
				}

				const timeClockAnalysisResult = _.get(r, 'timeClockAnalysisResults.0', {});

				this.setState({
					timeClockAnalysisResult,
					isTimeClockFetching: false,
				});
				callback(null, { timeClockAnalysisResult });
			},
		});
	};

	handleSavingClosed = () => {};
	continueSavingDialog = () => {
		this.props.clearSaving();
		this.props.history.push(this.props.onSuccessRedirectTo);
	};

	handleLogout = () => {
		const deviceToken = localStorage.getItem('mobilePushDeviceToken') || undefined;
		this.props.logout({ deviceToken });
	};

	handleAuthErrorClosed = () => {
		this.setState({ isAuthErrorClosed: true });
	};

	handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		this.setState({ pushNotificationIsOpen: false });
	};

	render() {
		// noinspection JSMismatchedCollectionQueryUpdate
		const {
			//width,
			classes,
			savingStatus,
			savingMessage,
			savedMessage,
			errorMessages = [],
			location,
			//showErrors,
		} = this.props;
		const { timeClockAnalysisResult, isTimeClockFetching } = this.state;
		let isCurrentlyClockedIn = timeClockAnalysisResult
			? timeClockAnalysisResult.isCurrentlyClockedIn
			: false;

		const isSavingOpen = !!savingStatus;
		let isErrorDialogOpen = errorMessages.length !== 0;

		const authError = _.get(location, 'state.authError');
		const isAuthErrorDialogOpen = this.state.isAuthErrorClosed ? false : !!authError;

		isCurrentlyClockedIn = true;
		return (
			<div className={classes.root}>
				{isTimeClockFetching ? (
					<div
						style={{
							padding: '2vw',
							fontSize: '150%',
							textAlign: 'center',
							color: '#555',
							fontWeight: 200,
							fontStyle: 'italic',
							marginTop: '5vw',
						}}
					>
						<CircularProgress style={{ marginRight: 10, marginBottom: -5 }} />
						<span>Fetching time clock info...</span>
					</div>
				) : isCurrentlyClockedIn ? (
					this.renderRoutes()
				) : (
					<PleaseClockIn />
				)}

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>

				<ErrorDialog
					onClose={this.handleAuthErrorClosed}
					errorMessages={[authError]}
					open={isAuthErrorDialogOpen}
				/>

				<SavingDialog
					open={isSavingOpen}
					onClose={this.handleSavingClosed}
					onContinue={this.continueSavingDialog}
					processingText={savingMessage}
					successText={savedMessage}
					status={savingStatus}
				/>

				<Snackbar
					width="100%"
					classes={{
						root: classes.pushRoot,
					}}
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'center',
					}}
					open={this.state.pushNotificationIsOpen}
					//autoHideDuration={2000}
					//onClose={this.handleSnackbarClose}
					TransitionComponent={SlideUpTransition}
				>
					<SnackbarContent
						className={classes.pushContainer}
						aria-describedby="push message"
						message={
							<div id="client-snackbar" className={classes.pushInner}>
								<InfoIcon className={classes.pushIcon} />
								{this.state.pushNotificationMessage}
							</div>
						}
						action={[
							<div className={classes.pushActions}>
								<IconButton
									key="close"
									aria-label="close"
									color="inherit"
									onClick={() => {
										this.props.history.go(0);
									}}
								>
									<Refresh className={classes.icon} />
									<span className={classes.pushButton}>Reload</span>
								</IconButton>
								<IconButton
									key="close"
									aria-label="close"
									color="inherit"
									onClick={this.handleSnackbarClose}
								>
									<CloseIcon className={classes.icon} />
									<span className={classes.pushButton}>Close</span>
								</IconButton>
								,
							</div>,
						]}
					/>
				</Snackbar>

				<div style={{ position: 'fixed', bottom: 0, width: '100%', zIndex: 20 }}>
					<BottomNavigation
						showLabels
						style={{ height: '20vw', backgroundColor: '#D8D8D8' }}
						value={this.state.navTab}
						onChange={(_event, value) => {
							console.log('value', value);

							if (value === TAB_VALUES.LOGOUT) {
								return;
							}

							if (value === TAB_VALUES.HOME) {
								this.props.history.push('/mobile');
							}
							this.setState({ navTab: value });
						}}
					>
						<BottomNavigationAction
							label="Home"
							icon={<HomeIcon className={classes.bottomIcon} />}
							classes={{ label: classes.bottomLabel }}
						/>
						<BottomNavigationAction
							label="Logout"
							icon={<LogoutIcon className={classes.bottomIcon} />}
							classes={{ label: classes.bottomLabel }}
							onClick={this.handleLogout}
						/>
					</BottomNavigation>
				</div>
			</div>
		);
	}

	renderRoutes = () => {
		return (
			<Switch>
				<Route exact path="/mobile/">
					<Dashboard />
				</Route>
				<Route exact path="/mobile/debugCommodities" component={DebugCommodities} />
				<Route exact path="/mobile/dashboard" component={Dashboard} />
				<Route component={NoMatch} />
			</Switch>
		);
	};
}

MobileLayout.propTypes = {
	classes: PropTypes.object.isRequired,
	logout: PropTypes.func.isRequired,
	width: PropTypes.string,

	//- error
	errorMessages: PropTypes.array,
	clearError: PropTypes.func,

	//- props for generic saving
	onSuccessRedirectTo: PropTypes.string,
	savingStatus: PropTypes.string,
	savingMessage: PropTypes.string,
	savedMessage: PropTypes.string,
	clearSaving: PropTypes.func,

	history: PropTypes.object,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles), LayoutContainer])(MobileLayout);
